import { incrementGetFileProviderItemsRequestCount } from './helpers/getFileProviderItemsRequestCount';
import loadMoreItemsForSelectedProvider from './loadMoreItemsForSelectedProvider';
import { getFilePickerStore } from '../store/filePickerStore';
import { action } from 'satcheljs/lib/legacy';

export default action('refreshFileProviderItems')(function refreshFileProviderItems() {
    incrementGetFileProviderItemsRequestCount();
    loadMoreItemsForSelectedProvider(getFilePickerStore().viewState, true);
});
